///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp = abcsetup.consumer_rfp || {};
abcsetup.consumer_rfp.humana = abcsetup.consumer_rfp.humana || {};
abcsetup.consumer_rfp.humana.create = abcsetup.consumer_rfp.humana.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp.humana.create = {
    itemsSelect: null,
    init() {

        this.itemsSelect = $('#app_a_b_c_item__item_ids');
        this.suppliersSelect = $('#app_models_consumer_r_f_p_supplier__supplier_ids');
        abc_item_org = '';
        abc_item_id = '';
        abcsetup.setTitle('Add Consumer RFP Event');
        abcsetup.consumer_rfp.humana.common.init();
        abcsetup.consumer_rfp.humana.common.setupEventBindings();

        // Autopopulate consumer rfp name field based on crfp type, item(s) selected, and end date of auction
        $('#app_models_consumer_r_f_p__consumer_rfp_type_id, #app_models_consumer_r_f_p__end_date, #app_a_b_c_item__item_ids').on('change', event => {

            const _event_target = $(event.target);
            const selectedItems = this.itemsSelect;
            const itemsSelected = this.itemsSelect.val();
            const suppliersSeleced = this.suppliersSelect;
            const selectedSupplier = this.suppliersSelect.val();
            var itemName = '';
            if (itemsSelected) {
                itemName = this.itemsSelect.find(`option[value=${itemsSelected[0]}]`).text();
            }
            const itemCount = itemsSelected.length;
            const supplierCount = selectedSupplier.length;

            if (itemCount == 1 && abc_item_id == '') {
                if (selectedItems.find(`option[value=${itemsSelected[0]}]`).length) {
                    selectedItems.find(`option[value=${itemsSelected[0]}]`).attr('data-abc_item_org',selectedSupplier[0]);
                }
            }

            if (supplierCount == 1 && abc_item_org == '') {
                if (suppliersSeleced.find(`option[value=${selectedSupplier[0]}]`).length) {
                    suppliersSeleced.find(`option[value=${selectedSupplier[0]}]`).addClass(itemsSelected[0]);
                }
            }

            // toggle the disabled property of the Add matched item buttons based on the contents of itemsSelected
            $(`button.add_abc_item_to_rfp_items`).prop('disabled',false);
            itemsSelected.forEach(item => {
                $(`button.add_abc_item_to_rfp_items[data-abc_item_id="${item}"]`).prop('disabled',true);
            });
            // var formattedDate = new Date(Date.parse($('#app_models_consumer_r_f_p__end_date').val())).format("MM/dd/yyyy");

            var name = $("#app_models_consumer_r_f_p__consumer_rfp_type_id option:selected").text() + ' :: ' + itemName + (itemCount > 1 ? ' + ' + (itemCount-1) + ' item(s) ' : '') + ' :: ' + $('#app_models_consumer_r_f_p__end_date').val();
            $('#app_models_consumer_r_f_p__consumer_rfp_name').val(name);

        });

        // Check if there are prev and next items
        // If there aren't, leave buttons as disabled.
        if ($('.previous_humana_item').data('prev')) {
            $('.previous_humana_item').removeClass('disabled');
        }

        if ($('.next_humana_item').data('next')) {
            $('.next_humana_item').removeClass('disabled');
        }
        $(".add_abc_item_to_rfp_items").on("click", event => {
            const _add_btn = $(event.target);
            abc_item_id = _add_btn.data("abc_item_id");
            const abc_item_descr = _add_btn.data("abc_item_descr");
            const abc_item_sap = _add_btn.data("abc_item_sap");
            const abc_item_vendor_id = _add_btn.data("abc_item_vendor_id");
            const abc_item_vendor = _add_btn.data("abc_item_vendor");
            abc_item_org=_add_btn.data("abc_item_org");

            if (this.itemsSelect.find(`option[value=${abc_item_id}]`).length) {
                this.itemsSelect.find(`option[value=${abc_item_id}]`).prop('selected', true).attr('data-abc_item_org',abc_item_org);
            } else {
                const newOption = new Option(`(${abc_item_sap}) ${abc_item_descr}`, abc_item_id, true, true);
                newOption.setAttribute('data-abc_item_org',abc_item_org);
                this.itemsSelect.append(newOption);
            }
            this.itemsSelect.trigger("change");


            if (this.suppliersSelect.find(`option[value=${abc_item_org}]`).length) {
                this.suppliersSelect.find(`option[value=${abc_item_org}]`).prop('selected', true);
            }
            else {
                const newOption = new Option(`${abc_item_vendor} (${abc_item_vendor_id})`, abc_item_org, true, true);
                newOption.setAttribute('class',abc_item_id);
                this.suppliersSelect.append(newOption);
            }
            this.suppliersSelect.trigger("change");
        });

        $('#app_a_b_c_item__item_ids').on('select2:unselect', function (e) {
            var abc_item_id = e.params.data.id;
            var suppliersSelect = $('#app_models_consumer_r_f_p_supplier__supplier_ids');
            var itemSelect = $('#app_a_b_c_item__item_ids');
            var org;

            if (itemSelect.find(`option[value=${abc_item_id}]`).length) {
                org = itemSelect.find(`option[value=${abc_item_id}]`).data("abc_item_org");
            }

            if (suppliersSelect.find(`option[value=${org}]`).length) {
                suppliersSelect.find(`option[value=${org}]`).prop('selected', false);
            }
            suppliersSelect.trigger("change");
        });

        $(".clear_suppliers").on("click", event => {
            $("#app_models_consumer_r_f_p_supplier__supplier_ids").val(null).trigger('change');
        });
    },

    fieldsInit() {
        $('#app_models_consumer_r_f_p__all_suppliers').trigger('change');
    },

    /**
     * _jquery.uploader
     *      An upload is complete this is the callback
     */
    uploadDone() {
        if (abcsetup.uploader.uploadResult.type === 'importSuppliers') {
            abcsetup.consumer_rfp.humana.common.importSuppliers(abcsetup.uploader.uploadResult.vals);
        } else if (abcsetup.uploader.uploadResult.type === 'importItems') {
            abcsetup.consumer_rfp.humana.common.importItems(abcsetup.uploader.uploadResult.vals, abcsetup.uploader.uploadResult.extras);
        }
    },
}